import styled from 'styled-components';

export const Header = styled.header`
  min-height: 10.6rem;
  background: #242424;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 5.8rem;

  position: sticky;
  top: 0;

  @media (max-width: 425px) {
    padding: 0 2rem;
  }
`;

export const HeaderWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;

export const HeaderLabel = styled.span`
  font-size: 2.5rem;
  color: #ffdf22;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1.25px;
  margin-left: 0.6rem;
`;

export const HeaderCount = styled.span`
  font-size: 1.8rem;
  color: #fff;
`;

export const Container = styled.ul`
  padding: 7.2rem 3.1rem;

  overflow: auto;
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 425px) {
    padding: 4rem 3.1rem;
  }
`;

export const Navigator = styled.button`
  width: 43.9rem;
  height: 6.9rem;
  border-radius: 0.4rem;
  background-color: #fff;

  margin-right: 6.4rem;
  margin-bottom: 4.9rem;

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 4.2rem;
  }

  svg {
    transform: scaleX(-1);
  }

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 3.2rem;

  cursor: pointer;

  transition: filter 0.3s;

  :hover {
    filter: brightness(0.9);
  }
`;

export const NavigatorTitle = styled.span`
  font-size: 2.1rem;
  font-weight: bold;
  text-transform: capitalize;
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 1;

  height: 80%;

  > h1 {
    color: #ffdf22;
  }
`;

export const ExercisesNotFoundMessage = styled.div`
  color: white;
  width: 100%;
  text-align: center;
  font-size: 2rem;
`;

export const DeleteExerciseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 3rem;
    text-transform: uppercase;
  }

  p {
    width: 80%;
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 6rem;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    button {
      width: 10rem;
      height: 4rem;
      background: transparent linear-gradient(96deg, #000000 0%, #232323 100%)
        0% 0% no-repeat padding-box;
      border-radius: 50px;
      opacity: 1;

      color: #fff;
      font-weight: bold;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`;

export const AdminExercisesButton = styled.button`
  background: linear-gradient(107deg, #ffd503 0%, #ffdf22 100%);
  border-radius: 5rem;
  padding: 1rem 4rem;
  font-size: 2rem;
`;
